<!-- <div id="okta-login-container"></div> -->

<main class="py-16">

    <section id="program-login" class="container mx-auto max-w-screen-xl prose leading-normal px-8 xl:px-0" *ngIf="!activationCodeFlag">
        <div class="program-login__intros flex justify-center gap-x-16">
            <div class="program-login__icon basis-1/4 hidden md:block">
                <div class="callout-circle__blue">
                    <img src="https://assets.syngentaebiz.com/images/media/ssp-icon-login-wave.svg" alt="Illustration of a user" class="w-[300px] h-[300px] object-center object-scale-down my-0">
                </div>
            </div>
            <div class="program-login__main md:basis-2/4" id="logScreen">
                <p class="text-[22px] sm:text-[24px] mt-0 md:mt-8">Ready to share your feedback and track your rewards?<br>Log in to your <em>Storen Satisfaction Program</em> account.</p>
                <div class="program-login__form grid grid-cols-1 mt-8">
                 
                    <label for="emailAddress" class="block">
                        <span><span class="required-asterisk">*</span>Email Address</span>
                        <input id="emailAddress" name="emailAddress" type="email" class="mt-1 block w-full" placeholder="" required [(ngModel)]="emailAddress" (focusout)="validateUser($event)"/>
                    </label>
                    <span *ngIf="showErrorMessageEmail" class="error-message mt-2 text-red-500">
                        {{ errorMessageEmail }}
                    </span>
                    <span *ngIf="errLogin" class="error-message mt-2 text-red-500">
                      {{ errorLoginMsg }}
                  </span>
                    <label for="password" class="block mt-top" *ngIf="showPasswordfield">
                        <span><span class="required-asterisk">*</span>Password</span>
                        <input id="password" name="password" type="password" class="mt-1 block w-full" placeholder="" required [(ngModel)]="password" />
                    </label>
                    <span *ngIf="errorMessage" class="error-message mt-2 text-red-500">
                        {{ errorMessage }}
                    </span>
                    <label for="keepSignedIn" class="inline-flex items-center mt-2">
                        <input id="keepSignedIn" name="keepSignedIn" type="checkbox" [(ngModel)]="keepmeSignedIn"/>
                        <span class="ml-2">Keep me signed in.</span>

                    </label>
                    <div class="program-login__submit mt-top">
                        <button id="btnLogin" type="button" class="btn__blue" data-measurement="SSP - Login - Submit" *ngIf="!showPasswordfield" [disabled]="disbaleNextbtn" (click)="next()">Next</button>
                        <button id="btnLogin" type="button" class="btn__blue" *ngIf="showPasswordfield" data-measurement="SSP - Login - Submit" (click)="login()">Login</button>
                    </div>
                </div>

                <div class="program-login__forgot">
                    <p class="mb-16 md:mb-8">
                        <a id="forgotPassword" data-measurement="SSP - Login - Forgot Paassword" href="javascript:void(0);" (click)="frgtPasswd()">Forgot password?</a>
                    </p>
                </div>
            </div>
        </div>
    </section>


 <!---------------------activation page ------------------->
 <section id="program-login_activation" class="container mx-auto max-w-screen-xl prose leading-normal px-8 xl:px-0" *ngIf="activationCodeFlag" >
      
  <div class="program-login__intros flex text-center justify-center gap-x-16" id="logActivate">
      
      <div class="program-login__main md:basis-4/4">
          <!-- <p class="text-[32px] sm:text-[32px] mt-0 md:mt-8">Login Storen</p> -->
          <p class="text-[32px] sm:text-[36px] mt-0 mb-4 md:mt-8" #logActivateT><em>Just one more step..</em></p>
          <p class="text-[20px] sm:text-[18px] mt-0 md:mt-8">Click the button below to begin using your Storen account</p>
          <div class="program-login__submit mt-8 md:mt-8">
              <button id="btnActivate" type="button" class="btn__blue" (click)="activateAccount()">Activate your account</button>
          </div>
      </div>
    
     
  </div>

</section>



</main>


  

<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true" *ngIf="activateFlag">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
        <div class="bg-white text-center pt-3 pb-2">
         
            
              <h3 class="text-center font-bold mt-4 text-[20px] md:text-[20px]" id="modal-title">Information</h3>
             
                <p class="text-[16px] md:text-[16px] p-4 pb-3">{{activeMsg}}</p>
              
         
        </div>
        <div class="bg-white-20 px-4 py-3 mt-0 mb-3  text-center">
          <button type="button" class="btn__blue closebtn" (click)="loginbtn()">Login</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true" *ngIf="errFlagPop">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
        <div class="bg-white text-center pt-4 pb-2">
         
           
              <!-- <h3 class="text-base font-semibold text-gray-900" id="modal-title">Alert</h3> -->
              <p class="text-[18px] md:text-[18px] text-center pt-4">Oops! Something went wrong. Please try again later.</p>
           
         
        </div>
        <div class="bg-white-20 px-3 mt-3 mb-4 py-3 text-center">
          <button type="button" class="btn__blue closebtn" (click)="errFlagPop=false">Close</button>
        </div>
      </div>
    </div>
	
  </div>
</div>
